import { status } from "nprogress";
import {
  GET_SDKLOGINTOKEN_FAILED,
  GET_SDKLOGINTOKEN_LOADING,
  GET_SDKLOGINTOKEN_REMOVE,
  GET_SDKLOGINTOKEN_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
  Token: null,
};

export const getSdkLoginTokenReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
  switch (action.type) {
    case GET_SDKLOGINTOKEN_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_SDKLOGINTOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        Token: action.payload?.message,
        error: null,
        status: action?.status,
      };
    case GET_SDKLOGINTOKEN_FAILED:
      return {
        ...state,
        loading: false,
        Token: null,
        error: action.error,
        status: action?.status,
      };
    case GET_SDKLOGINTOKEN_REMOVE:
      return initialState;
    default:
      return state;
  }
};
